<template>
    <div class="row ml-xl-4 m-0">
        <div class="col-12">
            <h3>
                <b>Monedero:</b> <Button v-if="abonado.user_id" @click="$modal.show('addMonedero');" icon="fas fa-plus" class="ml-2">Añadir</Button>
                <addMonedero :abonado="abonado" v-on:close="$emit('actualizar');"/>
            </h3> 
        </div>
        <div v-if="transaciones" class="col-12">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>Descripcion</th>
                        <th>Importe</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(transacion, index) in transaciones">
                        <tr :key="index">
                            <td class="w-25">{{ transacion.descripcion }}</td>
                            <td>{{ transacion.importe }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-number
                last-number
            />
            <h6>Total: {{total}}</h6>
            
        </div>
        <div v-else class="col-12">
            <p>No tiene un monedero</p>
        </div>
    </div>
</template>

<script>
    import addMonedero from '@/views/backend/abonados/modals/addMonedero';
    export default {
        props: ['abonado'],
        data() {
            return {
                rows: 1,
                perPage: 1,
                currentPage: 1,
                transaciones: null,
                total: 0,
            }
        },
        created() {
            this.getMonedero();
        },
        methods: {
            getMonedero() {
                const data = {
                    abonado_id: this.abonado.id,
                    filters : {
                        page: this.currentPage,
                    },
                }
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.monedero'), data).then(res => {
                    if(! res.data.error) {
                        this.rows = res.data.meta.last_page
                        this.perPage = res.data.meta.per_page > 5 ? res.data.per_page : 1;
                        this.currentPage = res.data.meta.current_page
                        this.transaciones = res.data.data;
                        this.total = res.data.total;
                    }                
                });
            }
        },
        watch: {
            currentPage() {
                this.getMonedero();
            }
        },
        components: {addMonedero}
    
    }
</script>